const templatesList = [
    {
        id: '01',
        type: "factory",
        name: 'Factory contract',
        blockchain: 'Ethereum',
        shortDescription:
            'Deploy your own factory smart contract on the Ethereum blockchain',
        masterDescription:
            'Deploy master factory smart contract on the Ethereum blockchain',
        description:
            'Factory contract available to deploy any kind of contract',
        image: '../../assets/img/NFT_Icon.png',
        link: 'https://eips.ethereum.org/EIPS/eip-721',
    },
    // {
    //     id: '02',
    //     type: 'ERC1155',
    //     name: 'ERC 1155 NFT',
    //     blockchain: 'Ethereum',
    //     shortDescription:
    //         'Deploy your own ERC 1155 smart contract on the Ethereum blockchain',
    //     masterDescription:
    //         'Deploy master ERC 1155 smart contract on the Ethereum blockchain',
    //     description:
    //         'A standard interface for contracts that manage multiple token types. A single deployed contract may include any combination of fungible tokens, non-fungible tokens or other configurations (e.g. semi-fungible tokens).',
    //     image: '../../assets/img/NFT_Icon.png',
    //     link: 'https://eips.ethereum.org/EIPS/eip-1155',
    // },
    // {
    //     id: '03',
    //     type: 'ERC20',
    //     name: 'ERC 20',
    //     blockchain: 'Ethereum',
    //     shortDescription:
    //         'Deploy your own ERC 20 smart contract on the Ethereum blockchain',
    //     masterDescription:
    //         'Deploy master ERC 20 smart contract on the Ethereum blockchain',
    //     description:
    //         'A simple ERC 20 contract for all your needs',
    //     image: '../../assets/img/NFT_Icon.png',
    //     link: 'https://eips.ethereum.org/EIPS/eip-20',
    // },
    // {
    //     id: '03',
    //     type: 'ERC721UPG',
    //     name: 'ERC 721 Upgradeable NFT',
    //     blockchain: 'Ethereum',
    //     shortDescription:
    //         'Deploy a upgradable ERC 721 smart contract on the Ethereum blockchain',
    //     masterDescription:
    //         'Deploy a upgradable ERC 721 smart contract on the Ethereum blockchain',
    //     description:
    //         'A Non-Fungible Token (NFT) is used to identify something or someone in a unique way. This type of Token is perfect to be used on platforms that offer collectible items, access keys, lottery tickets, numbered seats for concerts and sports matches, etc. This special type of Token has amazing possibilities so it deserves a proper Standard, the ERC-721 came to solve that!\nThis contract is fully upgradable.',
    //     image: '../../assets/img/NFT_Icon.png',
    //     link: 'https://eips.ethereum.org/EIPS/eip-721',
    // },
    // {
    //     id: '04',
    //     type: 'ERC1155UPG',
    //     name: 'ERC 1155 Upgradeable NFT',
    //     blockchain: 'Ethereum',
    //     shortDescription:
    //         'Deploy a upgradable ERC 1155 smart contract on the Ethereum blockchain',
    //     masterDescription:
    //         'Deploy a upgradable ERC 1155 smart contract on the Ethereum blockchain',
    //     description:
    //         'A standard interface for contracts that manage multiple token types. A single deployed contract may include any combination of fungible tokens, non-fungible tokens or other configurations (e.g. semi-fungible tokens).\nThis contract is fully upgradable.',
    //     image: '../../assets/img/NFT_Icon.png',
    //     link: 'https://eips.ethereum.org/EIPS/eip-1155',
    // },
];

export { templatesList };
